import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment.local';

@Injectable({
    providedIn: 'root',
})
export class SimulatorConfigService {
    constructor(private http: HttpClient) {}

    public async getAblePriceSimulator(): Promise<boolean> {
        try {
          const response = await firstValueFrom(this.http.get<boolean>(`${environment.apiUrls.simulationConfig}/economic-group/enabled`));
          return response;
        } catch {
          return false;
        }
    }

    public async getAbleSimulatorAudit(): Promise<boolean> {
      try {
        const response = await firstValueFrom(this.http.get<boolean>(`${environment.apiUrls.simulationConfig}/simulator-audit/enabled`));
        return response;
      } catch {
        return false;
      }
  }
    
}